import { render } from "./PageNumber7.vue?vue&type=template&id=6c3f30a8&scoped=true"
import script from "./PageNumber7.vue?vue&type=script&lang=js"
export * from "./PageNumber7.vue?vue&type=script&lang=js"

import "./PageNumber7.vue?vue&type=style&index=0&id=6c3f30a8&scoped=true&lang=css"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3f30a8"]])

export default __exports__